import { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);

export function MemberProvider({ children }) {
  const [members, setMembers] = useState([]);
  const [activeMemberId, setActiveMemberId] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshMembers = useCallback(async () => {
    try {
      const m = await api("/members");
      setMembers(m);
    } catch {
      setMembers([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshMembers();
  }, [refreshMembers]);

  const memberById = useCallback((id) => members.find((m) => m.id === id), [members]);

  const value = useMemo(
    () => ({ members, activeMemberId, setActiveMemberId, refreshMembers, memberById, loading }),
    [members, activeMemberId, refreshMembers, memberById, loading]
  );

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useMembers() {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error("useMembers must be used within MemberProvider");
  return ctx;
}
